module.exports = __webpack_public_path__ + "img/crypto-seed-phrase-storage_B096HQ3KGX.976b1cb9.jpg";